import React, { useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Upload } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const UserImport = ({ onImportComplete }) => {
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.name.endsWith('.xls') || file.name.endsWith('.xlsx')) {
        setSelectedFile(file);
      } else {
        toast.error('Por favor selecciona un archivo Excel (.xls o .xlsx)');
      }
    }
  };

  const handleImport = async () => {
    if (!selectedFile) {
      toast.error('Por favor selecciona un archivo');
      return;
    }

    setUploading(true);

    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('file', selectedFile);

      const response = await axios.post(`${API}/admin/users/import`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      const result = response.data;
      
      toast.success(
        `Importación completada: ${result.created} creados, ${result.updated} actualizados, ${result.skipped} omitidos`
      );

      if (result.errors && result.errors.length > 0) {
        console.warn('Errores durante importación:', result.errors);
        toast.warning(`Se encontraron ${result.errors.length} errores. Revisa la consola.`);
      }

      setSelectedFile(null);
      if (onImportComplete) {
        onImportComplete();
      }
    } catch (error) {
      console.error('Error importing users:', error);
      toast.error('Error al importar clientes');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="bg-blue-50 border-2 border-blue-300 rounded-xl shadow-lg p-6">
      <h3 className="text-xl font-bold text-slate-900 mb-2 flex items-center">
        <Upload className="w-5 h-5 mr-2" />
        Importar Clientes desde Excel
      </h3>
      <p className="text-sm text-slate-600 mb-4">
        Sube un archivo Excel con clientes. Todos serán aprobados automáticamente con contraseña: <strong>123456789</strong>
      </p>
      
      <div className="space-y-3">
        <div>
          <input
            type="file"
            accept=".xls,.xlsx"
            onChange={handleFileSelect}
            className="block w-full text-sm text-slate-600
              file:mr-4 file:py-2 file:px-4
              file:rounded-full file:border-0
              file:text-sm file:font-semibold
              file:bg-blue-600 file:text-white
              hover:file:bg-blue-700
              cursor-pointer"
          />
        </div>
        
        {selectedFile && (
          <div className="bg-white p-3 rounded-lg border border-blue-200">
            <p className="text-sm font-medium text-slate-900">
              Archivo seleccionado: {selectedFile.name}
            </p>
            <p className="text-xs text-slate-500">
              {(selectedFile.size / 1024).toFixed(2)} KB
            </p>
          </div>
        )}
        
        <Button
          onClick={handleImport}
          disabled={!selectedFile || uploading}
          className="w-full bg-blue-600 hover:bg-blue-700"
        >
          {uploading ? 'Importando...' : 'Importar Clientes'}
        </Button>
      </div>
      
      <div className="mt-4 pt-4 border-t border-blue-200">
        <p className="text-xs text-slate-500">
          <strong>Formato esperado del Excel:</strong> Código, Nombre Tienda, Provincia, Teléfono, Nombre Responsable, Email
        </p>
      </div>
    </div>
  );
};

export default UserImport;
